import { Checkbox, Divider, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { pushEmeraldModal } from '../common/emerald-modal-manager/emerald-modal-manager';
import { INotification } from '../common/interfaces/dtos/INotification';
import { AppState } from '../common/redux/configure-store';
import Pagination from '../pagination/pagination';
import { styles } from './notification-styles';
import NotificationTitle from './notifications-title';
import EmeraldModal from 'src/common/components/emerald-modal/emerald-modal';

type Props = INotificationProps & INotificationModalState;

export const showNotificationDialog = (props: INotificationModalState): void => {
  pushEmeraldModal(<NotificationComponent {...props} />);
};

const NotificationModal: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles();
  const { onCheck, onClose } = props;

  return (
    <EmeraldModal open disablePortal data-testid='notifications-modal'>
      <Grid container direction='column' className={classes.main} justifyContent='space-between'>
        <Grid item>
          <NotificationTitle notificationCount={props.notifications.length} />
        </Grid>
        <Grid item className={classes.contentContainer}>
          <Grid container direction='column' data-testid='notifications-row-container'>
            {props.notifications.map((notification: INotification, index) => (
              <Grid item key={notification.notificationId} data-testid={`notificationrow-${index}`}>
                <Grid container>
                  <Grid item>
                    <Typography
                      className={classes.notificationIndex}
                      data-testid={`notification-index-${index}`}
                    >
                      {index + 1}.
                    </Typography>
                  </Grid>
                  <Grid item className={classes.notificationContent}>
                    <Grid container direction='column'>
                      <Grid item>
                        <Grid container justifyContent='space-between'>
                          <Grid item className={classes.notificationDetailsContainer}>
                            <Grid container direction='column'>
                              <Grid item>
                                <Typography
                                  className={classes.notificationTitle}
                                  data-testid={`notification-title-${index}`}
                                >
                                  {notification.title}
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography
                                  className={classes.notificationMessage}
                                  data-testid={`notification-content-${index}`}
                                >
                                  {notification.content}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item>
                            <Checkbox
                              defaultChecked={false}
                              inputProps={{
                                //@ts-ignore
                                'data-testid': `notification-checkbox-${index}`,
                              }}
                              onChange={event => {
                                if (event.target.checked) {
                                  onCheck(
                                    notification.notificationId || '',
                                    notification.instanceId || '',
                                  );
                                }
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        className={classes.divider}
                        data-testid={`notification-divider${index}`}
                        style={{
                          display: `${index + 1 === props.notifications.length ? 'none' : 'block'}`,
                        }}
                      >
                        <Divider />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid container item className={classes.bottomContainer}>
          <Grid item container className={classes.paginationContainer} justifyContent='center'>
            <Pagination
              currentPage={1}
              totalPages={1}
              updateCurrentPageHandler={() => {}}
              testIdPrefix={'notifications'}
            />
          </Grid>
          <Grid item>
            <BaseButton buttonType='primary' data-testid='notifications-ok-btn' onClick={onClose}>
              ok
            </BaseButton>
          </Grid>
        </Grid>
      </Grid>
    </EmeraldModal>
  );
};

interface INotificationProps {
  notifications: INotification[];
}

interface INotificationModalState {
  onClose: () => void;
  onCheck: (notificationId: string, instanceId: string) => void;
}

const mapStateToProps = (state: AppState): INotificationProps => ({
  notifications: state.notification.notifications,
});

const NotificationComponent = connect(mapStateToProps)(NotificationModal);
export default NotificationComponent;
